import { render } from "./AdminReports.vue?vue&type=template&id=7dd8fc04&scoped=true&ts=true"
import script from "./AdminReports.ts?vue&type=script&lang=ts"
export * from "./AdminReports.ts?vue&type=script&lang=ts"

import "./AdminReports.vue?vue&type=style&index=0&id=7dd8fc04&scoped=true&lang=scss"

import exportComponent from "D:\\Melinda\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd8fc04"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QSpinner});
